import * as React from 'react';
import IMPComponent from '../interfaces/IMPComponent';
import styled from 'styled-components';

interface IPageContentProps extends IMPComponent {
  dateId: string;
  text: string;
}

const Pre = styled.pre`
  flex-grow: 1;
  /* for Firefox */
  min-height: 0;
  margin-top: 0;

  color: ${p => p.theme.color.black2};
  font-family: ${p => p.theme.font.secondary};
  font-size: ${p => p.theme.font.size.large};
  line-height: 1.66em;
  word-break: break-word;
  white-space: pre-wrap;
`;

const Container = styled.div`
  padding-bottom: 300px;
  margin-top: 20px;
`;

const PageContent = ({ dateId, text }: IPageContentProps) => {
  return (
    <Container>
      <Pre heap-ignore={true} data-private={true} data-page-id={dateId}>
        {text}
      </Pre>
    </Container>
  );
};

export default React.memo(PageContent);



// WEBPACK FOOTER //
// ./src/components/PageContent/index.tsx